<template>
  <div>
    <div class="container">
      <!-- LOGIN -->
      <Login
        v-if="currentPage === 'loginPage'"
        @loginData="Login"
        @toRegister="toRegister"
        @googleToken="googleToken"
      >
      </Login>

      <!-- REGISTER PAGE -->
      <Register
        v-if="currentPage === 'registerPage'"
        @registerData="Register"
        @toLogin="toLogin"
      ></Register>
    </div>

    <!-- HOMEPAGE -->
    <div class="home" v-if="currentPage === 'home'">
      <!-- DASHBOARD -->
      <Dashboard
        @getFoodList="getFoodList"
        @getAddFoodForm="getAddFoodForm"
        @HistoryLog="HistoryLog"
      ></Dashboard>

      <!-- MAIN CONTENT -->
      <div id="main" class="col-md-10">
        <!-- FOOD LIST -->
        <Foodlist
          v-if="currentMain === 'FoodList'"
          @getDetailFood="getDetailFood"
          @toEdit="toEdit"
        ></Foodlist>

        <!-- History Log -->
        <History
          v-if="currentMain === 'History'"
          @backToList="backToList"
        ></History>

        <!-- DETAIL FOOD -->
        <Fooddetail
          v-if="currentMain === 'FoodDetail'"
          @backFromDetail="backFromDetail"
          :foodDetailData="foodDetailData"
        ></Fooddetail>

        <!-- ADD FOOD -->
        <Addfood
          v-if="currentMain === 'AddFood'"
          class="container form-add-food"
          method="POST"
          @toFoodList="toFoodList"
        ></Addfood>

        <!-- EDIT FOOD -->
        <Foodedit
          v-if="currentMain === 'EditFood'"
          class="container form-edit-food"
          method="PUT"
          @toFoodList="toFoodList"
          :populateFood="populateFood"
        ></Foodedit>
      </div>
    </div>
  </div>
</template>

<script>
import Login from "./views/login.vue";
import Register from "./views/register.vue";
import Dashboard from "./views/dashboard.vue";
import Foodlist from "./views/food-list.vue";
import Fooddetail from "./views/food-detail.vue";
import Addfood from "./components/form.vue";
import Foodedit from "./components/form.vue";
import History from "./components/History.vue";
import axios from "./apis/server";

export default {
  name: "App",
  components: {
    Login,
    Register,
    Dashboard,
    Foodlist,
    Fooddetail,
    Addfood,
    Foodedit,
    History,
  },
  data() {
    return {
      currentPage: "loginPage",
      currentMain: "FoodList",
      populateFood: [],
    };
  },
  methods: {
    Login(payload) {
      axios({
        url: "/login",
        method: "POST",
        data: payload,
      })
        .then(({ data }) => {
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Logged In",
            showConfirmButton: false,
            timer: 1500,
          });
          localStorage.setItem("access_token", data.access_token);
          this.currentPage = "home";
          this.foodList = "On";
        })
        .catch((err) => {
          Swal.fire({
            title: "Error!",
            text: err.response.data.message,
            icon: "error",
            confirmButtonText: "Cool",
          });
        });
    },
    Register(regisData) {
      axios({
        url: "/register",
        method: "POST",
        data: regisData,
      })
        .then(({ data }) => {
          console.log(data);
          this.currentPage = "loginPage";
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: data.msg,
            showConfirmButton: false,
            timer: 1500,
          });
        })
        .catch((err) => {
          Swal.fire({
            title: "Error!",
            text: err.response.data.message,
            icon: "error",
            confirmButtonText: "Cool",
          });
        });
    },
    getFoodList() {
      this.currentMain = "FoodList";
    },
    getAddFoodForm() {
      this.currentMain = "AddFood";
    },
    backToList() {
      this.currentMain = "FoodList";
    },
    getDetailFood(detailFood) {
      this.foodDetailData = detailFood;
      this.currentMain = "FoodDetail";
    },
    backFromDetail() {
      this.currentMain = "FoodList";
    },
    toRegister() {
      this.currentPage = "registerPage";
    },
    toLogin() {
      this.currentPage = "loginPage";
    },
    toEdit(food) {
      this.populateFood = food;
      this.currentMain = "EditFood";
    },
    toFoodList() {
      this.currentMain = "FoodList";
    },
    HistoryLog() {
      this.currentMain = "History";
    },
    googleToken(token) {
      axios({
        url: "/login-google",
        method: "POST",
        data: { token: token },
      }).then(({ data }) => {
        localStorage.setItem("access_token", data.access_token);
        this.currentPage = "home";
      });
    },
  },
  created() {
    if (localStorage.getItem("access_token")) {
      this.currentPage = "home";
    } else {
      this.currentPage = "loginPage";
    }
  },
};
</script>

<style>
</style>